import { Module, ActionContext } from 'vuex';
import { IAppConfig } from '@/model/IAppConfig';
import { IAppRootState } from './IAppRootState';
import { TjipVuexAction, TjipVuexMutation } from '@tjip/vuejs';
import { appConfigService } from '@/services/appConfigService';

export class AppConfigDataModule implements Module<IAppConfig, IAppRootState> {
  public namespaced = true;

  public state: IAppConfig;

  constructor() {
    this.state = {
      loaded: false,
      authBaseUri: 'http://localhost:5001',
      authClientId: 'ongeldig',
      iDealPaymentsDisabled: true,
      ppfAdviseurZoekenUrl: 'https://www.philipspensioenfonds-hypotheek.nl',
      ppfInfoMailAddress: 'ppf.hypotheken@blackrock.com',
      ppfWebsiteUrl: 'https://www.philipspensioenfonds-hypotheek.nl',
      ppfDeclaratieBouwdepotUrl: 'https://www.philipspensioenfonds-hypotheek.nl',
      ppfMachtigingIncassoUrl: 'https://www.philipspensioenfonds-hypotheek.nl',
      ppfTaxatierapportVoorwaardenUrl: 'https://www.philipspensioenfonds-hypotheek.nl',
      ppfCalcasaTaxatieAanvragenUrl: 'https://app.desktoptaxatie.nl/taxatie',
      ppfContactUrl: 'https://www.philipspensioenfonds-hypotheek.nl',
      ppfDisclaimerUrl: 'https://www.philipspensioenfonds-hypotheek.nl',
      ppfPrivacyCookiesUrl: 'https://www.philipspensioenfonds-hypotheek.nl',
      fileUpload: {
        accept: 'pdf',
        maxSize: 25000000
      }
    };
  }

  @TjipVuexAction
  protected init(ctx: ActionContext<IAppConfig, IAppRootState>): Promise<any> {
    return ctx.dispatch('getConfig', false);
  }

  @TjipVuexAction
  private getConfig(ctx: ActionContext<IAppConfig, IAppRootState>, force = false): Promise<IAppConfig> {
    if (force || !ctx.state.loaded) {
      return appConfigService.getConfig(force).then((config: IAppConfig) => {
        config.loaded = true;
        ctx.commit('getConfigSucceeded', config);
        return ctx.state;
      });
    }
    return Promise.resolve(ctx.state);
  }

  @TjipVuexAction
  private reset() {
    // do nothing
  }

  @TjipVuexMutation
  private getConfigSucceeded(state: IAppConfig, config: IAppConfig) {
    Object.assign(state, config);
  }
}
